<template>
  <div>
    <!-- Header -->
    <div class="d-flex justify-content-between align-items-center mb-4 flex-wrap gap-2">
      <h2 class="mb-0">Pass Types</h2>
      <b-button class="btn btn-secondary" href="#/passtypes/new">
        Create Pass Type
      </b-button>
    </div>

    <!-- Filter -->
    <b-form class="mb-3">
      <b-row>
        <b-col cols="12" sm="8" md="6" lg="4" xl="3">
          <b-input-group size="lg">
            <b-form-input
              id="search_query"
              class="form-control form-control-lg form-control form-control-md"
              v-model="query"
              type="text"
              placeholder="Search pass types..."
              @input="searchQuery"
            ></b-form-input>
            <b-input-group-append>
              <b-button variant="outline-secondary" @click="query = ''; searchQuery()">
                Clear
              </b-button>
            </b-input-group-append>
          </b-input-group>
        </b-col>
      </b-row>
    </b-form>

    <!-- Table -->
    <v-server-table
      id="pass_types_table"
      ref="pass_types_table"
      :columns="columns"
      :options="options"
      @loading="onLoading"
      @loaded="onLoaded"
      @row-click="rowClicked"
    >
      <!-- Delete Button -->
      <template slot="delete_pass_type" slot-scope="props">
        <b-button
          variant="danger"
          size="sm"
          @click.stop="deletePassType(props.row)"
        >
          <icon name="trash" />
        </b-button>
      </template>

      <!-- Replace Lost Checkbox -->
      <template slot="replace_lost" slot-scope="props">
        <b-form-checkbox v-model="props.row.replace_lost" disabled></b-form-checkbox>
      </template>

      <!-- Loading Spinner -->
      <div slot="afterBody" v-show="loading">
        <div class="overlay-loader"></div>
        <icon scale="1" name="spinner" spin class="clip-loader"></icon>
      </div>
    </v-server-table>
  </div>
</template>


<script>

import api from '../api'
import moment from 'moment'
moment.locale('en-nz');


export default {
  name: "PassTypes",
  data() {
    return {
      columns: ['name', 'price', 'type', 'age', 'days_limit', 'delete_pass_type', 'organisation_name'],
      data: [],
      options: {
        headings: {
          name: 'Name',
          price: 'Price',
          type: 'Type',
          age: 'Age group',
          days_limit:'Days limit',
          delete_pass_type: 'Delete',
          organisation_name: 'Organisation Name'
        },
        perPage: 50,
        sortable: [],
        pagination: {
          dropdown:false
        },
        requestFunction: function (data) {
            if (api.userIsAdmin()) {
              data.showAll = true;
            }

            return api.getAllPassTypes(data)
              .catch(function (e) {
                this.dispatch('error', e);
            }.bind(this));
        },
        responseAdapter(response) {
          return {
            data: response.data.ret_msg,
            count: response.data.ret_msg.length > 0? response.data.ret_msg[0].full_count: 0
          }
        }
      },
      enabled: true,
      loading: false,
      deleting: false,
      query:null
    }
  },
  methods: {
    onLoading(event){
      this.loading = true;
    },
    onLoaded(event){
      this.loading = false;
    },
    rowClicked(event) {
      if(this.deleting){
        this.deleting = false;
      }else {
        window.location.href = "/#/passtypes/" + event.row.id;
      }
    },
    deletePassType(row){
      if(!confirm('Are you sure you want to delete this pass type? This will disable check-ins from any passes of this pass type!'))
      this.loading = true;
      this.deleting = true;
      api.deletePassType(row.id).then(function(ignore){
        this.$refs.pass_types_table.refresh();
      }.bind(this));
    },
    searchQuery() {
    this.$refs.pass_types_table.setFilter(this.query)
    }
  }
}

</script>

<style>
  table {
    width: 100%;
    position: relative;
  }

  .overlay-loader {
    position: absolute;
    top: 0;
    width: 100%;
    height: 100%;
    background-color: white;
    opacity: 0.8;
    filter: blur(5px);
  }

  .clip-loader {
    position: absolute;
    left: 50%;
    right: 50%;
    bottom: 60%;
    top: 40%;
    width: 60px;
    height: 60px;
  }

  #pass_types_table td{
    cursor: pointer;
  }

  .VueTables__search {
    display: none;
  }

</style>





// WEBPACK FOOTER //
// src/components/PassTypes.vue